
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.75 10.947c2.897 0 5.25 2.116 5.25 4.722 0 2.157-1.62 3.984-3.818 4.543a.34.34 0 00-.267.32v.888c0 .57-.488 1.049-1.11 1.079-.665.03-1.22-.45-1.22-1.049v-.918a.34.34 0 00-.267-.32C9.132 19.653 7.511 17.846 7.5 15.7c0-.569.5-1.058 1.132-1.078.666-.01 1.199.46 1.199 1.058 0 1.508 1.42 2.726 3.13 2.616 1.432-.09 2.597-1.138 2.697-2.426.122-1.528-1.232-2.816-2.908-2.816-2.897 0-5.25-2.126-5.25-4.732 0-2.157 1.62-3.984 3.818-4.543a.34.34 0 00.267-.32V2.58c0-.57.488-1.049 1.11-1.079.665-.03 1.22.45 1.22 1.049v.918c0 .15.111.28.267.32C16.379 4.347 17.989 6.154 18 8.3c0 .569-.5 1.058-1.132 1.078-.655.01-1.199-.46-1.199-1.058 0-1.508-1.42-2.726-3.13-2.616-1.432.09-2.597 1.138-2.697 2.436-.122 1.528 1.232 2.806 2.908 2.806z","fill":"#8F7A61"}})])
          )
        }
      }
    